import React from "react";
import styles from "./Header.module.css";
import { useNavigate } from "react-router-dom";
import { Input, Space } from "antd";
import { AudioOutlined, SearchOutlined } from "@ant-design/icons";
import { apiGet, apiPost } from "../../utils/axiosFn";
import { Link } from "react-router-dom";
import Phone from "../../assets/images/Phone.svg";
import weibo from "../../assets/images/weibo.svg";
import weixin from "../../assets/images/weixin.svg";
import logo from "../../assets/images/logo.png";
import LOGO from "../../assets/logo.png";

interface NavListType {
  navList?: { vlaue: string; label: string }[] | undefined;
}

declare global {
  interface Window {
    netscape: any;
    sidebar: any;
  }
}

const withHeaderClass = (Children: any) => {
  return (props: any) => {
    const navigate = useNavigate();
    const window = Window;
    return <Children {...props} navigate={navigate} window={window} />;
  };
};

class HeaderClassComponent extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      navList: [],
      time: null,
      week: null,
      navActive: 999,
    };
  }

  async componentDidMount() {
    const navActive = window.sessionStorage.getItem("active");
    this.setState({ navActive });

    this.time();
    const { navList } = this.state;
    try {
      const res = await apiGet("/api/common/articleTypeList", null, null, null);
      this.setState({ navList: res });
    } catch (error) {
      alert(error);
    }
  }

  time = () => {
    var date = new Date(); //获取当前日期
    var year = date.getFullYear(); //获取当前年份
    var month = date.getMonth() + 1; //获取当前月份（记得+1）
    var dates = date.getDate(); //获取当前是几日
    var day = date.getDay(); //获取当前是星期几 周一返回1，周六返回6，周日返回0
    var arr = [
      "星期日",
      "星期一",
      "星期二",
      "星期三",
      "星期四",
      "星期五",
      "星期六",
    ];
    this.setState({ time: `${year}年${month}月${dates}日`, week: arr[day] });
  };

  goToPages = (item: any) => {
    return () => {
      const { navigate } = this.props;
      navigate(`/item/${item.label}`, {
        state: { id: item.label, text: item.title },
      });
      window.sessionStorage.setItem("active", item.value);
    };
  };

  onSearch = (e: any) => {
    const { navigate } = this.props;
    navigate(`/search/${e}`, {
      state: { id: e, text: e },
    });
  };

  SetHome = (obj: any, url: any) => {
    return () => {
      try {
        obj.style.behavior = "url(#default#homepage)";
        obj.setHomePage(url);
      } catch (e) {
        if (window.netscape) {
          try {
            window.netscape.security.PrivilegeManager.enablePrivilege(
              "UniversalXPConnect"
            );
          } catch (e) {
            alert(
              "抱歉，此操作被浏览器拒绝！\n\n请在浏览器地址栏输入“about:config”并回车然后将[signed.applets.codebase_principal_support]设置为'true'"
            );
          }
        } else {
          alert(
            "抱歉，您所使用的浏览器无法完成此操作。\n\n您需要手动将【" +
              url +
              "】设置为首页。"
          );
        }
      }
    };
  };

  AddFavorite = (obj: any, url: any) => {
    return () => {
      try {
        obj.external.addFavorite(url, window.document.title);
      } catch (e) {
        try {
          window.sidebar.addPanel(window.document.title, url, "");
        } catch (e) {
          alert(
            "抱歉，您所使用的浏览器无法完成此操作。\n\n加入收藏失败，请使用Ctrl+D进行添加"
          );
        }
      }
    };
  };

  render() {
    const { navList, time, week, navActive } = this.state;

    const { navigate } = this.props;
    const { Search } = Input;
    return (
      <>
        <div className={styles["header"]}></div>
        <div className={styles["w-box"]}>
          <div className={styles["agagh"]}>
            <div
              onClick={this.SetHome(this, window.location.href)}
              className={styles["orjhg"]}
            >
              设为主页
            </div>
            <div
              onClick={this.AddFavorite(this, window.location.href)}
              className={styles["orjhg"]}
            >
              加入收藏
            </div>
          </div>
          <div
            className={styles["logo-box"]}
            style={{ display: "felx", justifyContent: "space-between" }}
          >
            <div
              onClick={() => navigate("/")}
              style={{
                cursor: "pointer",
                fontSize: "28px",
                color: "#005999",
                fontFamily: "SimHei",
                fontWeight: "900",
                width: "600px",
                marginTop: "0",
              }}
            >
              <img
                style={{ width: "300px", height: "100%", marginTop: "-30px" }}
                src={LOGO}
                alt=""
              />
            </div>
            <Search
              className={styles["search"]}
              placeholder="请输入关键字"
              prefix={<SearchOutlined />}
              onSearch={this.onSearch}
              enterButton="搜索"
            />
            {/* <div style={{ display: "flex", alignItems: "center" }}>
              <div className={styles["phone"]}>
                <img src={Phone} alt="" />
                手机版(建设中)
              </div>
              <div>
                <img src={weixin} alt="" style={{ marginLeft: "20px" }} />
                公众号(建设中)
              </div>
              <div>
                <img src={weibo} alt="" style={{ marginLeft: "20px" }} />
                微博(建设中)
              </div>
            </div> */}
          </div>
        </div>
        <div className={styles["aaaa"]}>
          <div className={styles["nav-box"]}>
            <div
              style={{
                background: "999" == navActive ? "#ae0f10" : "",
              }}
              onClick={() => {
                navigate("/");
                window.sessionStorage.setItem("active", "999");
              }}
            >
              首页
              <span
                style={{
                  display: navActive == "999" ? "none" : "flex",
                }}
              ></span>
            </div>
            {navList.map((item: any) => {
              return (
                <div
                  key={item.value}
                  style={{
                    background: item.value == navActive ? "#ae0f10" : "",
                  }}
                  onClick={this.goToPages(item)}
                >
                  {item.label}
                  <span
                    style={{
                      display: navActive == item.value ? "none" : "flex",
                    }}
                  ></span>
                </div>
              );
            })}
            <div
              style={{
                background: "1000" == navActive ? "#ae0f10" : "",
              }}
              onClick={() => {
                navigate("/connactus");
                window.sessionStorage.setItem("active", "1000");
              }}
            >
              在线留言
              <span
                style={{
                  display: navActive == "1000" ? "none" : "flex",
                }}
              ></span>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export const HeaderClass = withHeaderClass(HeaderClassComponent);
